import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullish } from '../utils';

export function checkObjectMask(validatedKeys: string[], isTemplate = false) {
  return (checkAll: boolean = true) => {
    return (control: AbstractControl) => {
      const { value } = control;

      if (isTemplate && !value) {
        return null;
      }

      if (!value) {
        return null;
      }

      if (!value || typeof value !== 'object') {
        return { objectMask: true };
      }

      const checkFn = (key) => value.hasOwnProperty(key);

      const isValid = checkAll
        ? validatedKeys.every(checkFn)
        : validatedKeys.some(checkFn);

      return isValid ? null : { objectMask: true };
    };
  };
}

export function checkMissingValuesValidator(keys?: string[]) {
  return (checkAll: boolean = true) => {
    return (control: AbstractControl): ValidationErrors | null => {
      const { value } = control;

      if (!value || typeof value !== 'object') {
        return null;
      }

      const checkFn = (key) => !isNullish(value[key]);

      const validatedKeys = !!keys.length ? keys : Object.keys(value);
      const isValid = checkAll
        ? validatedKeys.every(checkFn)
        : validatedKeys.some(checkFn);

      return isValid ? null : { missingValues: true };
    };
  };
}


export function dividedBySpaceValidator(control: AbstractControl): ValidationErrors | null {
  const value = (control.value || '').trim();
  if (!value) return null;

  const parts = value.split(/[\s,]+/);
  return parts.length >= 2 ? null : { twoParts: true };
}
